<template>
  <div class="betalok-lab">
    <div class="betalok-lab__bg">
      <picture v-for="(bg, ind) in background.list" :key="ind">
        <source
          :srcset="`
            https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/bg/${bg}_mob.jpg
          `"
          media="(max-width: 1220px)"
        />
        <source
          :srcset="`
            https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/bg/${bg}.jpg
          `"
        />
        <img
          class="betalok-lab__bg-img"
          :class="[`betalok-lab__bg-img_${ind}`]"
          :style="background.active == ind ? '' : 'opacity: 0; display: none'"
          :src="`
            https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/bg/${bg}.jpg
          `"
        />
      </picture>
      <svg
        class="svg-animated d-none d-xl-block"
        v-if="
          activeScreen == 5 &&
          questions[4].answered &&
          questions[4].choice &&
          questions[4].answers.find((el) => el.label == questions[4].choice)
            .is_correct
        "
        width="1440"
        height="720"
        viewBox="0 0 1440 720"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M977.694 528.605C971.92 530.915 964.454 529.255 958.393 529.764C938.833 531.408 917.235 536.16 898.976 543.522C886.453 548.572 877.243 556.171 868.839 566.704C862.113 575.136 857.047 583.181 857.047 594.019C857.047 607.02 864.604 616.715 877.407 619.116C908.001 624.852 940.254 617.418 969.026 607.021C993.024 598.349 1020.29 581.869 1033.94 559.447C1043.56 543.643 1034 528.188 1016.55 524.221C1001.96 520.905 986.583 522.492 972.05 525.178C951.767 528.927 932.489 534.827 913.289 542.212"
          stroke="#80170C"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
      <svg
        class="svg-animated d-xl-none"
        preserveAspectRatio="xMaxYMin meet"
        v-if="
          activeScreen == 5 &&
          questions[4].answered &&
          questions[4].choice &&
          questions[4].answers.find((el) => el.label == questions[4].choice)
            .is_correct
        "
        width="390"
        height="401"
        viewBox="0 0 390 401"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M140.542 229.96C137.101 231.337 132.653 230.348 129.042 230.651C117.387 231.63 104.519 234.462 93.6391 238.849C86.1773 241.857 80.6896 246.385 75.6827 252.661C71.6747 257.685 68.6562 262.478 68.6562 268.936C68.6562 276.683 73.159 282.459 80.7874 283.89C99.0164 287.308 118.234 282.878 135.377 276.683C149.676 271.516 165.921 261.697 174.053 248.337C179.785 238.92 174.094 229.712 163.693 227.348C155.001 225.372 145.838 226.318 137.179 227.918C125.094 230.152 113.607 233.668 102.167 238.068"
          stroke="#80170C"
          stroke-width="1.7875"
          stroke-linecap="round"
        />
      </svg>
      <svg
        class="svg-animated d-xl-none"
        preserveAspectRatio="xMaxYMin meet"
        v-if="
          activeScreen == 5 &&
          questions[4].answered &&
          questions[4].choice &&
          !questions[4].answers.find((el) => el.label == questions[4].choice)
            .is_correct
        "
        width="390"
        height="401"
        viewBox="0 0 390 401"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M61 235C95.9272 219.596 130.488 201.751 167 194"
          stroke="#80170C"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M55 202C73.8782 195.227 92.7426 188.267 111.946 182.569C127.559 177.936 143.053 175.67 159 173"
          stroke="#80170C"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>

      <svg
        class="svg-animated d-none d-xl-block"
        v-if="
          activeScreen == 5 &&
          questions[4].answered &&
          questions[4].choice &&
          !questions[4].answers.find((el) => el.label == questions[4].choice)
            .is_correct
        "
        width="1440"
        height="720"
        viewBox="0 0 1440 720"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M848.562 508.349C894.131 492.893 939.221 474.988 986.857 467.211"
          stroke="#80170C"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M834.562 457.58C854.423 450.833 874.269 443.901 894.471 438.226C910.896 433.612 927.196 431.355 943.973 428.695"
          stroke="#80170C"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
      <svg
        class="d-none d-xl-block"
        v-if="
          activeScreen == 6 &&
          questions[5].answered &&
          questions[5].choice &&
          !questions[5].answers.find((el) => el.label == questions[5].choice)
            .is_correct
        "
        width="1440"
        height="720"
        viewBox="0 0 1440 720"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="svg-animated"
          d="M1162.66 523C1162.4 527.303 1161.25 531.588 1160.37 535.78C1157.87 547.697 1155.17 559.602 1153.62 571.691C1153.02 576.362 1152.54 585.777 1152.54 585.777"
          stroke="#85190B"
          stroke-width="5"
          stroke-linecap="round"
        />
        <path
          class="svg-animated"
          d="M1125 541.633C1141.62 544.82 1158.07 549.94 1174.16 555.088C1180.81 557.214 1187.67 560.296 1194.66 561.073"
          stroke="#85190B"
          stroke-width="5"
          stroke-linecap="round"
        />
      </svg>
      <svg
        class="d-xl-none"
        preserveAspectRatio="xMaxYMin meet"
        v-if="
          activeScreen == 6 &&
          questions[5].answered &&
          questions[5].choice &&
          !questions[5].answers.find((el) => el.label == questions[5].choice)
            .is_correct
        "
        width="390"
        height="401"
        viewBox="0 0 390 401"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="svg-animated"
          d="M273.258 257.867C273.125 259.989 272.56 262.102 272.126 264.169C270.893 270.044 269.562 275.914 268.798 281.875C268.503 284.178 268.266 288.82 268.266 288.82"
          stroke="#85190B"
          stroke-width="2.46528"
          stroke-linecap="round"
        />
        <path
          class="svg-animated"
          d="M254.688 267.055C262.881 268.626 270.992 271.151 278.928 273.689C282.206 274.737 285.585 276.257 289.035 276.64"
          stroke="#85190B"
          stroke-width="2.46528"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen1"
      v-if="activeScreen == 0"
    >
      <div class="betalok-lab__screen-img">
        <img
          :srcset="`
            https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/professor.png 2x
          `"
        />
      </div>
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-title">Лаборатория</div>
            <div class="betalok-lab__screen-subtitle">профессора Зокуса*</div>
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-text mb-10 mb-md-4">
                Добро пожаловать к профессору Зокусу*!
                <br />
                В своей лаборатории он пытается создать препарат,который поможет
                тысячам пациентов с сердечно-сосудистыми заболеваниями. Однако,
                несмотря на его гениальные и чуточку безумные идеи, лишь одна
                проблема вот уже много лет не поддается решению — эффективный
                контроль ЧСС и АД.
              </div>
              <div class="betalok-lab__screen-text mb-5">
                Ответьте всего на несколько вопросов, и каждый правильный ответ
                приблизит вас с профессором
                <span>к созданию уникальной формулы!</span>
              </div>
              <div class="betalok-lab__screen-buttons">
                <div
                  class="betalok-lab__screen-button btn btn_violet"
                  @click="startQuiz"
                >
                  Начать &gt;
                </div>
                <div class="betalok-lab__screen-tip">*вымышленный персонаж</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen2 betalok-lab__screen-test"
      v-if="activeScreen == 1"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[0].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[0].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[0].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[0].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[0].choice"
                        :value="a.label"
                        v-if="!questions[0].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[0].choice == a.label &&
                            questions[0].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[0].answered &&
                              questions[0].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[0].answered &&
                              questions[0].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[0].choice == a.label &&
                              !questions[0].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[0].answered &&
                              questions[0].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[0].answered &&
                              questions[0].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[0].answered &&
                          questions[0].choice == a.label
                        "
                        v-html="questions[0].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[0].answered"
                @click="nextQuestion('3')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Следующий вопрос &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(0)"
                :class="{ button_disabled: !questions[0].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">01</div>
              /06
            </div>
            <Transition name="chat">
              <div
                class="betalok-lab__screen-professor-chat"
                v-if="message.active"
              >
                <div class="betalok-lab__screen-professor-chat-message">
                  <b v-html="message.title" v-if="message.title"></b>
                  <p v-html="message.text" v-if="message.text"></p>
                </div>
                <div class="betalok-lab__screen-professor-chat-avatar">
                  <img
                    :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/zokus/professor_chat.png 2x
                  `"
                  />
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen3 betalok-lab__screen-test"
      v-if="activeScreen == 2"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[1].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[1].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[1].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[1].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[1].choice"
                        :value="a.label"
                        v-if="!questions[1].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[1].choice == a.label &&
                            questions[1].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[1].answered &&
                              questions[1].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[1].answered &&
                              questions[1].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[1].choice == a.label &&
                              !questions[1].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[1].answered &&
                              questions[1].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[1].answered &&
                              questions[1].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[1].answered &&
                          questions[1].choice == a.label
                        "
                        v-html="questions[1].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[1].answered"
                @click="nextQuestion('4')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Следующий вопрос &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(1)"
                :class="{ button_disabled: !questions[1].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">02</div>
              /06
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen4 betalok-lab__screen-test"
      v-if="activeScreen == 3"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[2].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[2].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[2].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[2].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[2].choice"
                        :value="a.label"
                        v-if="!questions[2].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[2].choice == a.label &&
                            questions[2].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[2].answered &&
                              questions[2].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[2].answered &&
                              questions[2].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[2].choice == a.label &&
                              !questions[2].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[2].answered &&
                              questions[2].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[2].answered &&
                              questions[2].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[2].answered &&
                          questions[2].choice == a.label
                        "
                        v-html="questions[2].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[2].answered"
                @click="nextQuestion('5')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Следующий вопрос &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(2)"
                :class="{ button_disabled: !questions[2].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">03</div>
              /06
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen5 betalok-lab__screen-test"
      v-if="activeScreen == 4"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[3].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[3].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[3].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[3].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[3].choice"
                        :value="a.label"
                        v-if="!questions[3].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[3].choice == a.label &&
                            questions[3].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[3].answered &&
                              questions[3].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[3].answered &&
                              questions[3].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[3].choice == a.label &&
                              !questions[3].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[3].answered &&
                              questions[3].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[3].answered &&
                              questions[3].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[3].answered &&
                          questions[3].choice == a.label
                        "
                        v-html="questions[3].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[3].answered"
                @click="nextQuestion('6')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Следующий вопрос &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(3)"
                :class="{ button_disabled: !questions[3].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">04</div>
              /06
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen6 betalok-lab__screen-test"
      v-if="activeScreen == 5"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[4].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[4].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[4].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[4].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[4].choice"
                        :value="a.label"
                        v-if="!questions[4].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[4].choice == a.label &&
                            questions[4].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[4].answered &&
                              questions[4].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[4].answered &&
                              questions[4].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[4].choice == a.label &&
                              !questions[4].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[4].answered &&
                              questions[4].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[4].answered &&
                              questions[4].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[4].answered &&
                          questions[4].choice == a.label
                        "
                        v-html="questions[4].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[4].answered"
                @click="nextQuestion('7')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Следующий вопрос &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(4)"
                :class="{ button_disabled: !questions[4].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">05</div>
              /06
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen7 betalok-lab__screen-test"
      v-if="activeScreen == 6"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test">
                <div class="betalok-lab__screen-test-tip">
                  {{ questions[5].subtitle }}
                </div>
                <div class="betalok-lab__screen-test-question">
                  <div
                    class="betalok-lab__screen-test-question-title"
                    v-html="questions[5].title"
                  ></div>
                  <div
                    class="betalok-lab__screen-test-question-answers"
                    :class="{
                      'betalok-lab__screen-test-question-answers_disabled':
                        questions[5].answered,
                    }"
                  >
                    <label
                      class="betalok-lab__screen-test-question-answer"
                      v-for="(a, aInd) in questions[5].answers"
                      :key="aInd"
                    >
                      <input
                        type="radio"
                        v-model="questions[5].choice"
                        :value="a.label"
                        v-if="!questions[5].answered"
                      />
                      <div
                        class="betalok-lab__screen-test-question-answer-check"
                        :class="{
                          'betalok-lab__screen-test-question-answer-check_checked':
                            questions[5].choice == a.label &&
                            questions[5].answered,
                        }"
                      >
                        <div
                          class="betalok-lab__screen-test-question-answer-check-icon"
                          :class="{
                            'betalok-lab__screen-test-question-answer-check-icon_correct':
                              a.is_correct &&
                              questions[5].answered &&
                              questions[5].choice == a.label,
                            'betalok-lab__screen-test-question-answer-check-icon_wrong':
                              !a.is_correct &&
                              questions[5].answered &&
                              questions[5].choice == a.label,
                          }"
                        >
                          <div
                            class="betalok-lab__screen-test-question-answer-check-checked"
                            v-if="
                              questions[5].choice == a.label &&
                              !questions[5].answered
                            "
                          ></div>
                          <svg
                            v-if="
                              a.is_correct &&
                              questions[5].answered &&
                              questions[5].choice == a.label
                            "
                            width="16"
                            height="11"
                            viewBox="0 0 16 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.346 0.0452257C14.2676 0.0736686 14.141 0.133096 14.0646 0.177301C13.9877 0.221805 12.1045 2.00046 9.84569 4.16212L5.76566 8.06657L3.889 6.27793C2.15606 4.62633 1.99734 4.48304 1.81695 4.40749C1.5572 4.29871 1.30899 4.26252 1.0736 4.29913C0.382902 4.40653 -0.0987926 5.03987 0.0172769 5.68802C0.0859743 6.07159 0.0174644 5.9976 2.58913 8.46525C4.25744 10.0661 5.03022 10.7876 5.13919 10.8462C5.49509 11.0376 5.92044 11.051 6.29854 10.8828C6.5066 10.7903 6.69468 10.6147 11.1476 6.35396C14.5186 3.12848 15.7994 1.88471 15.8505 1.78676C16.1898 1.13697 15.9337 0.404605 15.2622 0.103816C15.0823 0.0232729 15.0101 0.00825871 14.77 0.00143959C14.5627 -0.00442246 14.451 0.00712232 14.346 0.0452257Z"
                              fill="white"
                            />
                          </svg>
                          <svg
                            v-if="
                              !a.is_correct &&
                              questions[5].answered &&
                              questions[5].choice == a.label
                            "
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0.478535 0.0230886C0.174059 0.122851 -0.023276 0.418093 0.00220811 0.735728C0.0242083 1.00978 -0.088739 0.885005 2.31472 3.2902L4.52324 5.50026L2.30576 7.72121C-0.174869 10.2057 0.00764902 9.99853 0.00764902 10.3293C0.00764902 10.5332 0.0605097 10.6629 0.20064 10.8031C0.340749 10.9432 0.470492 10.9961 0.674322 10.9961C1.00503 10.9961 0.797914 11.1787 3.28192 8.69756L5.50243 6.47965L7.71206 8.68652C9.48733 10.4595 9.94286 10.9035 10.0292 10.9447C10.1845 11.0189 10.4572 11.0183 10.6093 10.9435C10.7458 10.8763 10.8772 10.7448 10.9444 10.6084C10.9869 10.5219 10.997 10.4684 10.997 10.3293C10.997 9.99853 11.1795 10.2057 8.69895 7.72125L6.48151 5.50037L8.69895 3.27949C11.1795 0.795073 10.997 1.00221 10.997 0.671435C10.997 0.532353 10.9869 0.478837 10.9444 0.392368C10.8772 0.25591 10.7458 0.124421 10.6093 0.0572891C10.4572 -0.0175863 10.1845 -0.0181886 10.0292 0.0559985C9.94286 0.0972757 9.48733 0.541215 7.71202 2.31428L5.50232 4.52118L3.29263 2.31222C1.43781 0.457994 1.06566 0.0956195 0.9754 0.0558264C0.843442 -0.00235739 0.6043 -0.0181025 0.478535 0.0230886Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div
                          class="betalok-lab__screen-test-question-answer-check-label"
                          v-html="a.label"
                        ></div>
                      </div>
                      <div
                        class="betalok-lab__screen-test-question-answer-tip"
                        v-if="
                          questions[5].answered &&
                          questions[5].choice == a.label
                        "
                        v-html="questions[5].tip"
                      ></div>
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="questions[5].answered"
                @click="nextQuestion('8')"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Далее &gt;
              </div>
              <div
                v-else
                @click="answerQuestion(5)"
                :class="{ button_disabled: !questions[5].choice }"
                class="betalok-lab__screen-button btn btn_violet"
              >
                Ответ &gt;
              </div>
            </div>
          </div>
          <div class="betalok-lab__screen-info">
            <div class="betalok-lab__screen-number">
              <div class="betalok-lab__screen-number-active">06</div>
              /06
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen8 betalok-lab__screen-test-end"
      v-if="activeScreen == 7"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test-end">
                <div class="betalok-lab__screen-test-end-tip">
                  Ура, коллега!
                </div>
                <div class="betalok-lab__screen-test-end-text">
                  <div class="betalok-lab__screen-test-end-title">
                    Кажется, мы прошли через все этапы синтеза. Давайте
                    посмотрим на результаты!
                  </div>
                </div>
              </div>
              <div
                @click="
                  nextQuestion(
                    rightAnswers > 4
                      ? '9_right'
                      : rightAnswers > 2
                      ? '9_middle'
                      : '9_wrong'
                  )
                "
                class="betalok-lab__screen-button btn btn_violet"
              >
                Завершить квиз &gt;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="betalok-lab__screen betalok-lab__screen8 betalok-lab__screen-results"
      v-if="activeScreen == 8"
    >
      <div class="content">
        <div class="betalok-lab__screen-row">
          <div class="betalok-lab__screen-content">
            <div class="betalok-lab__screen-block blured-block">
              <div class="betalok-lab__screen-test-end">
                <div class="betalok-lab__screen-results-count">
                  <div class="betalok-lab__screen-number">
                    <div class="betalok-lab__screen-number-active">
                      {{ rightAnswers }}
                    </div>
                    /6
                  </div>
                </div>
                <div class="betalok-lab__screen-results-text">
                  <div
                    class="betalok-lab__screen-results-description"
                    v-if="rightAnswers > 4"
                  >
                    Ваши точные ответы помогли профессору синтезировать
                    молекулу, которая является делом всей его жизни!
                    <br />
                    <br />
                    Теперь вы можете <b>присоединиться к просмотру видео</b> и
                    узнать еще больше о бета-блокаторах!
                  </div>
                  <div
                    class="betalok-lab__screen-results-description"
                    v-else-if="rightAnswers > 2"
                  >
                    Немного разбитых колб и слегка взъерошенные волосы… Кажется
                    нам все еще не удалось создать молекулу для эффективного
                    контроля АД и ЧСС.Может быть, вы хотите попробовать своисилы
                    еще раз?
                    <br />
                    <br />
                    А чтобы точно правильно ответить на все вопросы, вы можете
                    <b>присоединиться к просмотру видео</b> и узнать еще больше
                    о бета-блокаторах!
                  </div>
                  <div class="betalok-lab__screen-results-description" v-else>
                    Легкий звон в ушах и непонятный дым… Кажется, нам не удалось
                    создать молекулу для эффективного контроля АД и ЧСС. Самое
                    время <b>попробовать пройти квиз еще раз</b>. А чтобы точно
                    обойтись без взрывных экспериментов, предлагаем вам
                    <b>присоединиться к просмотру видео</b> и узнать еще больше
                    о бета-блокаторах!
                  </div>
                </div>
              </div>

              <div class="betalok-lab__screen-results-buttons">
                <div
                  data-coolbox="https://storage.yandexcloud.net/sb-dev-most-static-01/media/content/public/assets/img/zokus/video.mp4"
                  class="betalok-lab__screen-button btn btn_violet"
                >
                  Смотреть видео
                  <svg
                    width="15"
                    height="22"
                    viewBox="0 0 15 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.9344 11.7998C14.4674 11.3998 14.4674 10.6002 13.9344 10.2002L1.60028 0.94277C0.941092 0.448011 0 0.918348 0 1.74256L0 20.2574C0 21.0817 0.941092 21.552 1.60028 21.0572L13.9344 11.7998Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  class="betalok-lab__screen-button btn btn_white"
                  @click="refreshQuiz"
                >
                  Попробовать еще &gt;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BetalokLabContent",
  props: {
    mute: Boolean,
  },
  data: () => ({
    sounds: {
      fuse: {
        url: "https://storage.yandexcloud.net/sb-dev-most-static-01/media/content/public/assets/img/zokus/sounds/fuse.ogg",
        audio: null,
      },
      glass_break: {
        url: "https://storage.yandexcloud.net/sb-dev-most-static-01/media/content/public/assets/img/zokus/sounds/glass_break.ogg",
        audio: null,
      },
      write: {
        url: "https://storage.yandexcloud.net/sb-dev-most-static-01/media/content/public/assets/img/zokus/sounds/write.ogg",
        audio: null,
      },
    },
    message: {
      active: false,
      title: "",
      text: "",
    },
    activeScreen: 0,
    background: {
      active: 0,
      list: [
        "1",
        "2",
        "2_wrong",
        "3",
        "3_right",
        "3_wrong",
        "4",
        "4_right",
        "4_wrong",
        "5",
        "5_right",
        "5_wrong",
        "6",
        "6_right",
        "6_wrong",
        "7",
        "7_right",
        "7_wrong",
        "8",
        "9_middle",
        "9_right",
        "9_wrong",
      ],
    },
    questions: [
      {
        subtitle: `Собираем оборудование для синтеза`,
        title: `Важное значение в терапии больных ИБС с сопутствующей АГ имеет контроль уровня АД с включением антигипертензивных средств.<sup>1</sup> Какой уровень АД согласно клиническим рекомендациям «Стабильная ИБС 2024» является пороговым для пациентов в возрасте < 65 лет, ниже которого снижение не рекомендовано?`,
        tip: `Согласно клиническим рекомендациям, первичная цель — достижение целевого уровня АД менее 140 и 90 мм рт. ст, а при условии хорошей переносимости
              и возраста до 65 лет — <b>не менее 120 и 70 мм рт. ст.<sup>1</sup></b>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "120 и 70 мм рт. ст.",
            is_correct: true,
          },
          {
            label: "140 и 90 мм рт. ст.",
            is_correct: false,
          },
          {
            label: "130 и 80 мм рт. ст.",
            is_correct: false,
          },
        ],
      },
      {
        subtitle: `Добавляем катализатор реакций`,
        title: `Согласно клиническим рекомендациям, 1-й линией терапии при стабильной стенокардии I-II ФКи ЧСС > 60 уд/мин являются:`,
        tip: `В таком случае именно бета-адреноблокаторы рекомендуется назначить в качестве препарата 1-й линии. А вот при стабильной стенокардии III-IV ФК, в отсутствие противопоказаний, уже рекомендуется назначить комбинацию β-АБс ДГП-БКК для достижения ФК I.<sup>1</sup>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "ингибиторы АПФ",
            is_correct: false,
          },
          {
            label: "β-адреноблокаторы",
            is_correct: true,
          },
          {
            label: "комбинация β-АБ+ДГП-БКК",
            is_correct: false,
          },
        ],
      },
      {
        subtitle: `Изучаем данные`,
        title: `Пациент с ИБС и АГ жалуется на эпизоды брадикардии вскоре после приема лекарства, а также тахикардию к концу интервала между его приемами. Из анамнеза известно, что ему назначен метопролола тартрат в дозе 50 мг 2 раза в сутки.Какое изменение в терапии может помочь избежать таких колебаний ЧСС?`,
        tip: `Особая форма выпуска метопролола сукцината — препарат Беталок<sup>®</sup> ЗОК — за счет контролируемого высвобождения позволяет поддерживать постоянство концентрации и отсутствие явных пиковых концентраций в плазме крови, способствует лучшейВ1-селективности по сравнению с обычными таблетированными формами метопролола тартрата и уменьшению потенциального риска побочных явлений. Таким образом, применение препарата Беталок<sup>®</sup> ЗОК может обеспечивать равный антигипертензивный эффект в дозе в 2 раза меньше.<sup>2-7</sup>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "Увеличение дозировки текущего бета-блокатора",
            is_correct: false,
          },
          {
            label: "Переход на бисопролол",
            is_correct: false,
          },
          {
            label:
              "Переход на метопролол сукцинат в форме ЗОК в стартовой дозе 50 мг х 1 раз в день",
            is_correct: true,
          },
          {
            label: "Добавление антиаритмика I класса (этацизин)",
            is_correct: false,
          },
        ],
      },
      {
        subtitle: `Историческое событие`,
        title: `Коллега, кажется, на синтез этой молекулы у меня ушла целая вечность… А знаете ли вы, в каком году β-АБ были впервые использованы при стенокардии?`,
        tip: `В 1962 году был впервые применен пропранолол при стенокардии.А уже в 1975 году вышла первая публикация о применении первого кардиоселективного β-АБ — метопролола.<sup>8</sup>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "1980-е",
            is_correct: false,
          },
          {
            label: "1960-е",
            is_correct: true,
          },
          {
            label: "1940-е",
            is_correct: false,
          },
        ],
      },
      {
        subtitle: `Не допустите повреждения атеросклеротической бляшки!`,
        title: `Вероятность разрыва атероматозной бляшки у пациента с ИБС:`,
        tip: `Доказанный факт, что высокая ЧСС у пациентов с ИБС является независимым фактором риска общей и сердечно-сосудистой смертности — при ЧСС>80 уд/мин увеличивается и вероятность разрыва атероматозной бляшки.<sup>5</sup>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "не зависит от уровня ЧСС",
            is_correct: false,
          },
          {
            label: "увеличивается при ЧСС>80 уд/мин",
            is_correct: true,
          },
          {
            label: "увеличивается при ЧСС>100 уд/мин",
            is_correct: false,
          },
        ],
      },
      {
        subtitle: `На пороге открытия`,
        title: `Перед вами пациент с жалобами на загрудинные боли и жжение. Возможно ли уменьшить количество приступов стенокардии напряжения в течение месяца в 5 раз?`,
        tip: `Конечно, неспроста! Согласно проведенным исследованиям,  в течение месяца терапии препаратом Беталок<sup>®</sup> ЗОК у пациентов со стабильной стенокардией количество приступов уменьшилось в 5 раз по сравнению с пациентами, получающими плацебо<sup>2,9</sup>`,
        choice: null,
        answered: false,
        answers: [
          {
            label: "Думаю, этот вопрос задан неспроста, и это возможно!",
            is_correct: true,
          },
          {
            label: "Сомневаюсь… звучит как что-то невозможное",
            is_correct: false,
          },
        ],
      },
    ],
  }),
  computed: {
    rightAnswers() {
      return this.questions.filter(
        (q) => q.answers.find((el) => el.label == q.choice).is_correct
      ).length;
    },
  },
  methods: {
    startQuiz() {
      this.changeBg("2");
      this.$set(this, "activeScreen", this.activeScreen + 1);
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "betalok quiz", {
          "Беталок - ЗОК Лаборатория": {
            "Начало квиза": {
              Params: {
                ...this.$root.ymFields,
              },
            },
          },
        });
        ym(91468266, "reachGoal", "betalok quiz", {
          "Беталок - ЗОК Лаборатория": {
            "Показ вопроса": {
              [`1_Собираем оборудование для синтеза`]: {
                Params: {
                  ...this.$root.ymFields,
                },
              },
            },
          },
        });
      }
    },
    changeBg(name) {
      const bgInd = this.background.list.findIndex((bg) => bg == name);
      window.scrollTo(0, 0);
      this.$set(this.background, "active", bgInd);
    },
    showMessage(title = "", text = "") {
      this.$set(this.message, "active", true);
      this.$set(this.message, "title", title);
      this.$set(this.message, "text", text);
    },
    answerQuestion(qInd) {
      this.$set(this.questions[qInd], "answered", true);
      if (qInd == 0) {
        if (
          this.questions[0].answers.find(
            (el) => el.label == this.questions[0].choice
          ).is_correct
        ) {
          this.showMessage(
            "Коллеги, вы абсолютно правы!",
            "Оборудование для синтеза собрано, двигаемся дальше."
          );
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`1_${this.questions[0].subtitle}`]: {
                    [`${
                      this.questions[0].answers.find(
                        (el) => el.label == this.questions[0].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.showMessage(
            "Коллеги, стоит подумать еще!",
            "Оборудование для синтеза испорчено..."
          );
          this.changeBg("2_wrong");
          if (!this.mute) {
            this.sounds.glass_break.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`1_${this.questions[0].subtitle}`]: {
                    [`${
                      this.questions[0].answers.find(
                        (el) => el.label == this.questions[0].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
      if (qInd == 1) {
        if (
          this.questions[1].answers.find(
            (el) => el.label == this.questions[1].choice
          ).is_correct
        ) {
          this.changeBg("3_right");
          if (!this.mute) {
            this.sounds.fuse.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`2_${this.questions[1].subtitle}`]: {
                    [`${
                      this.questions[1].answers.find(
                        (el) => el.label == this.questions[1].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.changeBg("3_wrong");
          if (!this.mute) {
            this.sounds.glass_break.audio.play();
            this.sounds.fuse.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`2_${this.questions[1].subtitle}`]: {
                    [`${
                      this.questions[1].answers.find(
                        (el) => el.label == this.questions[1].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
      if (qInd == 2) {
        if (
          this.questions[2].answers.find(
            (el) => el.label == this.questions[2].choice
          ).is_correct
        ) {
          this.changeBg("4_right");
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`3_${this.questions[2].subtitle}`]: {
                    [`${
                      this.questions[2].answers.find(
                        (el) => el.label == this.questions[2].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.changeBg("4_wrong");
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`3_${this.questions[2].subtitle}`]: {
                    [`${
                      this.questions[2].answers.find(
                        (el) => el.label == this.questions[2].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
      if (qInd == 3) {
        if (
          this.questions[3].answers.find(
            (el) => el.label == this.questions[3].choice
          ).is_correct
        ) {
          this.changeBg("5_right");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`4_${this.questions[3].subtitle}`]: {
                    [`${
                      this.questions[3].answers.find(
                        (el) => el.label == this.questions[3].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.changeBg("5_wrong");
          this.showMessage("Коллеги, стоит доверять проверенным фактам!");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`4_${this.questions[3].subtitle}`]: {
                    [`${
                      this.questions[3].answers.find(
                        (el) => el.label == this.questions[3].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
      if (qInd == 4) {
        if (
          this.questions[4].answers.find(
            (el) => el.label == this.questions[4].choice
          ).is_correct
        ) {
          this.changeBg("6_right");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`5_${this.questions[4].subtitle}`]: {
                    [`${
                      this.questions[4].answers.find(
                        (el) => el.label == this.questions[4].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.changeBg("6_wrong");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`5_${this.questions[4].subtitle}`]: {
                    [`${
                      this.questions[4].answers.find(
                        (el) => el.label == this.questions[4].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
      if (qInd == 5) {
        if (
          this.questions[5].answers.find(
            (el) => el.label == this.questions[5].choice
          ).is_correct
        ) {
          this.changeBg("7_right");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`6_${this.questions[5].subtitle}`]: {
                    [`${
                      this.questions[5].answers.find(
                        (el) => el.label == this.questions[5].choice
                      ).label
                    } верный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        } else {
          this.changeBg("7_wrong");
          if (!this.mute) {
            this.sounds.write.audio.play();
          }
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Ответ на вопрос": {
                  [`6_${this.questions[5].subtitle}`]: {
                    [`${
                      this.questions[5].answers.find(
                        (el) => el.label == this.questions[5].choice
                      ).label
                    } неверный`]: {
                      Params: {
                        ...this.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      }
    },
    nextQuestion(bgName) {
      this.$set(this, "activeScreen", this.activeScreen + 1);
      if (bgName) {
        if (bgName == "9_right") {
          this.sounds.fuse.audio.play();
        }
        if (bgName == "9_middle") {
          this.sounds.glass_break.audio.play();
        }
        if (bgName == "9_wrong") {
          this.sounds.glass_break.audio.play();
          this.sounds.fuse.audio.play();
        }
        this.changeBg(bgName);
        if (this.questions[this.activeScreen - 1]) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Показ вопроса": {
                  [`${this.activeScreen}_${
                    this.questions[this.activeScreen - 1].subtitle
                  }`]: {
                    Params: {
                      ...this.$root.ymFields,
                    },
                  },
                },
              },
            });
          }
        }
        if (this.activeScreen == 7) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "betalok quiz", {
              "Беталок - ЗОК Лаборатория": {
                "Прохождение квиза до конца": {
                  Params: {
                    ...this.$root.ymFields,
                  },
                },
              },
            });
          }
        }
      }
    },
    refreshQuiz() {
      this.$emit("refreshQuiz");
    },
  },
  mounted() {
    for (let sound in this.sounds) {
      const audio = new Audio(this.sounds[sound].url);
      this.$set(this.sounds[sound], "audio", audio);
    }
  },
};
</script>

<style lang="scss" scoped>
.betalok-lab {
  width: 100vw;
  aspect-ratio: 2 / 1;
  position: relative;
  display: flex;
  flex-direction: column;
  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: bottom right;

      @media screen and (max-width: 1220px) {
        &:not(.betalok-lab__bg-img_0) {
          object-fit: contain;
          object-position: top left;
          height: auto;
        }
        object-position: bottom left;
        background-color: #000;
      }

      @media screen and (max-width: 767px) {
        object-position: top left;
        object-fit: contain;
        height: 100%;
      }
    }

    & svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: bottom right;

      @media screen and (max-width: 1220px) {
        object-fit: contain;
        object-position: top left;
      }
    }
  }

  &__screen {
    height: 100%;
    min-height: max-content;
    position: relative;
    z-index: 4;
    flex-grow: 1;

    & .content {
      height: 100%;
    }

    &-row {
      padding: 66px 0;
      @media screen and (max-width: 767px) {
        padding-bottom: 0;
      }
    }

    &-test {
      & .content {
        display: flex;
        flex-direction: column;
      }

      .betalok-lab {
        &__screen {
          &-row {
            margin: auto 0;
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            gap: 48px;
            height: 100%;
            padding: 100px 0;

            @media screen and (max-width: 1220px) {
              padding: 100px 0 48px;
              flex-direction: column-reverse;
            }

            @media screen and (max-width: 767px) {
              padding: 66px 0 32px;
            }
          }

          &-content {
            width: 57%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;

            @media screen and (max-width: 1220px) {
              width: 100%;
            }
          }

          &-info {
            margin-left: auto;
            display: flex;
            flex-direction: column;
            @media screen and (max-width: 1220px) {
              height: 450px;
            }
            @media screen and (max-width: 767px) {
              height: 250px;
            }
          }

          &-block {
            margin: auto 0;
            padding: 30px;
            @media screen and (max-width: 767px) {
              padding: 16px 20px;
            }
          }

          &-test {
            &-tip {
              margin-bottom: 10px;
              padding: 4px 8px;
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 700;
              font-size: 22px;
              line-height: 120%;
              color: #ffffff;
              width: fit-content;
              background-color: #e881b7;
              border-radius: 10px;

              @media screen and (max-width: 767px) {
                font-size: 14px;
              }
            }

            &-question {
              &-title {
                margin-bottom: 20px;
                font-family: "Onest", sans-serif;
                font-style: normal;
                font-weight: 600;
                font-size: 22px;
                line-height: 120%;
                color: #ffffff;

                @media screen and (max-width: 767px) {
                  font-size: 14px;
                }
              }

              &-answers {
                margin-bottom: 20px;

                &_disabled {
                  pointer-events: none;
                }
              }

              &-answer {
                display: block;
                & input {
                  display: none;
                }
                &:not(:last-child) {
                  margin-bottom: 16px;
                }
                &-check {
                  cursor: pointer;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  gap: 12px;

                  &_checked {
                    & .betalok-lab__screen-test-question-answer-check-label {
                      font-weight: 700;
                    }
                  }

                  &-icon {
                    flex-shrink: 0;
                    width: 26px;
                    height: 26px;
                    border: 1px solid #fff;
                    border-radius: 3px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &_correct {
                      border-color: #0f962c;
                      background-color: #0f962c;
                    }

                    &_wrong {
                      border-color: #991e2f;
                      background-color: #991e2f;
                    }
                  }

                  &-label {
                    font-family: "Onest", sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 120%;
                    color: #ffffff;

                    @media screen and (max-width: 767px) {
                      margin: auto 0;
                      font-size: 14px;
                    }
                  }

                  &-checked {
                    width: 16px;
                    height: 16px;
                    background-color: #fff;
                    border-radius: 3px;
                  }
                }

                &-tip {
                  margin-top: 8px;
                  font-family: "Ruberoid", sans-serif;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 120%;
                  color: rgba(255, 255, 255, 0.9);

                  @media screen and (max-width: 767px) {
                    font-size: 12px;
                  }
                }
              }
            }
          }

          &-number {
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 180%;
            color: rgba(255, 255, 255, 0.4);

            @media screen and (max-width: 767px) {
              font-size: 16px;
            }

            &-active {
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 80px;
              line-height: 1;
              color: #ffffff;
              @media screen and (max-width: 767px) {
                font-size: 40px;
              }
            }
          }

          &-professor {
            &-chat {
              margin-top: auto;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              gap: 32px;

              &-avatar {
                flex-shrink: 0;
                @media screen and (max-width: 767px) {
                  width: 76px;
                }

                & img {
                  max-width: 100%;
                }
              }

              &-message {
                position: relative;

                padding: 16px;
                background-color: #fff;
                border-radius: 10px;
                font-family: "Onest", sans-serif;
                font-style: normal;
                font-size: 20px;
                line-height: 120%;
                color: #000000;

                @media screen and (max-width: 767px) {
                  padding: 10px 12px;
                  font-size: 14px;
                }

                &::before {
                  position: absolute;
                  z-index: -1;
                  top: 16px;
                  right: -16px;
                  width: 32px;
                  height: 32px;
                  border-radius: 4px;
                  display: block;
                  background: linear-gradient(
                    135deg,
                    #fff 50%,
                    transparent 50%
                  );
                  content: "";
                }

                & b {
                  font-weight: 600;
                }

                & p {
                  margin-top: 8px;
                }
              }
            }
          }
        }
      }
    }

    &-test-end {
      & .content {
        display: flex;
        flex-direction: column;
      }

      .betalok-lab {
        &__screen {
          &-row {
            margin: auto 0;
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            gap: 48px;
            height: 100%;
            padding: 100px 0;

            @media screen and (max-width: 767px) {
              padding: 66px 0 32px;
            }
          }

          &-content {
            width: 57%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;

            @media screen and (max-width: 1220px) {
              width: 100%;
              margin-top: 250px;
            }
          }

          &-info {
            margin-left: auto;
            display: flex;
            flex-direction: column;
          }

          &-block {
            margin: auto 0;
            padding: 30px;

            @media screen and (max-width: 767px) {
              padding: 10px 12px;
              font-size: 14px;
            }
          }

          &-test-end {
            &-tip {
              margin-bottom: 10px;
              padding: 4px 8px;
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 700;
              font-size: 36px;
              line-height: 120%;
              color: #ffffff;
              width: fit-content;
              background-color: #e881b7;
              border-radius: 10px;
              @media screen and (max-width: 767px) {
                font-size: 20px;
              }
            }

            &-title {
              margin-bottom: 20px;
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 600;
              font-size: 22px;
              line-height: 120%;
              color: #ffffff;
              @media screen and (max-width: 767px) {
                font-size: 18px;
              }
            }
          }
        }
      }
    }

    &-results {
      & .content {
        display: flex;
        flex-direction: column;
      }

      .betalok-lab {
        &__screen {
          &-row {
            margin: auto 0;
            display: flex;
            justify-content: flex-start;
            align-items: stretch;
            gap: 48px;
            height: 100%;
            padding: 100px 0;

            @media screen and (max-width: 767px) {
              padding: 66px 0 32px;
            }
          }

          &-content {
            width: 57%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;

            @media screen and (max-width: 1220px) {
              margin-top: 250px;
              width: 100%;
            }
          }

          &-info {
            margin-left: auto;
            display: flex;
            flex-direction: column;
          }

          &-block {
            margin: auto 0;
            padding: 30px;

            @media screen and (max-width: 767px) {
              padding: 16px 20px;
            }
          }

          &-results {
            &-description {
              margin-bottom: 20px;
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 22px;
              line-height: 120%;
              color: #ffffff;

              & b {
                font-weight: 600;
              }

              @media screen and (max-width: 767px) {
                font-size: 18px;
              }
            }

            &-buttons {
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              gap: 16px;

              @media screen and (max-width: 767px) {
                flex-direction: column;
                align-items: flex-start;
              }
            }
          }

          &-number {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 180%;
            color: rgba(255, 255, 255, 0.4);

            @media screen and (max-width: 767px) {
              font-size: 22px;
            }

            &-active {
              font-family: "Onest", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 120px;
              line-height: 1;
              color: #ffffff;

              @media screen and (max-width: 767px) {
                font-size: 80px;
              }
            }
          }
        }
      }
    }

    &1 {
      .betalok-lab {
        &__screen {
          &-img {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            width: 52%;

            @media screen and (max-width: 1220px) {
              display: none;
            }

            & img {
              width: 100%;
              object-fit: contain;
              object-position: bottom center;
            }
          }
          &-row {
            width: 50%;
            margin-left: auto;
            height: 100%;
            min-height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            position: relative;
            z-index: 1;

            @media screen and (max-width: 1220px) {
              width: 100%;
              margin-left: 0;
            }
          }

          &-title {
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 85px;
            line-height: 110%;
            text-transform: uppercase;
            color: #ffffff;
            text-shadow: 10px 5px 8.8px rgba(0, 0, 0, 0.25);

            @media screen and (max-width: 1220px) {
              font-size: 45px;
            }
          }

          &-subtitle {
            margin-bottom: 28px;
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 50px;
            line-height: 110%;
            color: #ffffff;
            background: linear-gradient(90deg, #d0016f 0%, #e570ae 100%);
            border-radius: 15px;
            padding: 8px 16px;
            width: fit-content;

            @media screen and (max-width: 1220px) {
              font-size: 30px;
            }
          }

          &-block {
            margin-bottom: 44px;
            padding: 20px 20px 20px 66px;

            @media screen and (max-width: 1220px) {
              margin-top: 650px;
            }

            @media screen and (max-width: 767px) {
              padding: 16px 20px;
              margin-top: 350px;
            }
          }

          &-text {
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 120%;
            color: #ffffff;

            @media screen and (max-width: 767px) {
              font-size: 16px;
            }
          }

          &-buttons {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
          }

          &-tip {
            margin-left: auto;
            font-family: "Onest", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 110%;
            color: #ebebeb;
          }
        }
      }
    }
  }

  .svg-animated {
    stroke-dasharray: 500;
    animation: svgAnimate 1s ease-in-out forwards;
  }

  @keyframes svgAnimate {
    from {
      stroke-dashoffset: 500;
    }

    to {
      stroke-dashoffset: 0;
    }
  }
}

.blured-block {
  backdrop-filter: blur(50px);
  background: #ffffff33;
  border-radius: 20px;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-family: "Onest", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  width: fit-content;
  transition: 0.3s;
  padding: 12px 28px;
  white-space: nowrap;
  border-radius: 10px;
  outline: none;
  text-decoration: none;
  border: 0;
  gap: 12px;

  &_violet {
    background-color: #3f0d50;
    color: #fff;

    &:hover {
      color: #3f0d50;
      background-color: #fff;
    }
  }

  &_white {
    background-color: #fff;
    color: #3f0d50;

    &:hover {
      color: #fff;
      background-color: #3f0d50;
    }
  }
}

.chat-enter-active,
.chat-leave-active {
  transition: 1s ease;
}

.chat-enter,
.chat-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.chat-enter-to,
.chat-leave-from {
  opacity: 1;
  transform: translateY(0px);
}
</style>

<style lang="scss">
.betalok-lab {
  & sup {
    vertical-align: super;
    font-family: inherit;
    font-style: normal;
    font-weight: inherit;
    font-size: 75%;
    line-height: 1;
    color: currentColor;
    white-space: nowrap;
  }

  & b {
    font-weight: 700;
  }
}
</style>